import { render, staticRenderFns } from "./Lk.vue?vue&type=template&id=a058acb8&scoped=true&"
import script from "./Lk.vue?vue&type=script&lang=js&"
export * from "./Lk.vue?vue&type=script&lang=js&"
import style0 from "./Lk.vue?vue&type=style&index=0&id=a058acb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a058acb8",
  null
  
)

export default component.exports